<script setup lang="ts">
/**
 * DR (Appoint Secretary) — 회사 단위 1부. 원본: DR (Appoint Secretary).docx
 *   선임 비서 목록([[if new_secretaries]] secretary_name (NRIC: secretary_identification_no))은 각 Form 45B 스코프에서 도출.
 *   서명 = 현직 이사 전원([[Signers]] → dr_Signers).
 */
import { inject, computed } from 'vue';
import CddVarField from '@/features/startTask/my_preset/sg/aura/agm/cdd/CddVarField.vue';
import AgmSigners from '@/features/startTask/my_preset/sg/aura/agm/cdd/AgmSigners.vue';
import '@/features/startTask/my_preset/sg/aura/agm/docs/agmDoc.css';

interface Row { name: string; nric: string }
const people = inject<any>('secPeople', null);
const newList = computed<Row[]>(() => (people?.value?.news as Row[]) || []);
</script>

<template>
  <div class="agm-doc">
    <table class="cdd-tbl hdr-tbl">
      <tbody>
        <tr><td class="hdr-l">Company Name:</td><td><CddVarField field-key="company_name" label="Company Name" /></td></tr>
        <tr><td class="hdr-l">UEN:</td><td><CddVarField field-key="company_registration_no" label="UEN" /></td></tr>
        <tr><td class="hdr-l">Document Type:</td><td>Directors Resolution</td></tr>
        <tr><td class="hdr-l">Date of Resolution:</td><td><CddVarField field-key="resolution_date" label="Resolution date" /></td></tr>
      </tbody>
    </table>

    <p class="sec-title">Appointment of Secretary(s):</p>
    <p class="doc-p">It was resolved that, the following person(s) having consented to act as Secretary(s) of the Company be and is/are hereby appointed:</p>
    <div v-if="newList.length" class="list">
      <div v-for="(d, i) in newList" :key="'n' + i" class="list-row">{{ d.name }} (NRIC: {{ d.nric }})</div>
    </div>
    <div v-else class="list-empty">(add secretaries in the &ldquo;Form 45B&rdquo; stage)</div>

    <p class="sec-title">Preparation of Documents:</p>
    <p class="doc-p">The secretary was requested to complete the documents required to reflect the change of the company.</p>

    <p class="sec-title">Signed by all company directors:</p>
    <AgmSigners var-key="dr_Signers" board-label="Directors" />
  </div>
</template>

<style scoped>
.hdr-tbl { width: auto; margin: 0 0 12px; }
.hdr-l { font-weight: 700; padding-right: 14px; white-space: nowrap; vertical-align: top; }
.list { margin: 4px 0 4px 8px; }
.list-row { padding: 2px 0; font-weight: 600; color: #10305c; }
.list-empty { margin: 4px 0 4px 8px; font-size: 11px; color: #b98900; font-style: italic; }
</style>
